import { formatDate } from '@kaiizen/kai-presenters';
import { ApiScan, ScanLifecycleStatus, ScanType } from '@kaiizen/kai-pro-api';
import { ScanStatus } from '@kaiizen/kai-scan-template-system';

import { StatusColor, StatusPill } from './StatusPill';

export const SCAN_STATUS_PRESENTATION_TEXT: { [key in ScanStatus | ScanLifecycleStatus]: string } = {
  created: 'Dispatch Pending',
  notStarted: 'Pending',
  dispatched: 'Pending',
  inProgress: 'In progress',
  pendingReview: 'Review Pending',
  inReview: 'Review In progress',
  reviewed: 'Reviewed',
  approved: 'Approved',
  rejected: 'Rejected',
  completed: 'Completed',
  correctionsRequested: 'Edits Requested',
};

export const SCAN_TYPE_PRESENTATION_TEXT: { [key in ScanType]: string } = {
  initial: 'Scope',
  final: 'Close Out', // DEPRECATED
  changeRequest: 'Change Order',
  progress: 'Scope', // if progress is active, we have an approved scope
  progressRework: 'Punch List',
  progressCompleted: 'Close Out',
  audienceDoc: 'Audience Doc',
};

const getScanStatusPillColor = (status?: ScanStatus | ScanLifecycleStatus, scanType?: ScanType): StatusColor => {
  if (!status && !scanType) {
    return 'gray';
  }

  switch (scanType) {
    case 'initial':
      return 'charcoal';
    case 'changeRequest':
      return 'darkOrange';
    case 'progressRework':
      return 'darkBlue';
    case 'audienceDoc':
      return 'gray';
    case 'final':
    case 'progressCompleted':
    case 'progress':
      return 'darkGreen';
  }

  switch (status) {
    case 'approved':
      return 'charcoal';
    case 'rejected':
      return 'red';
    case 'inReview':
      return 'red';
    case 'inProgress':
      return 'red';
    case 'pendingReview':
      return 'red';
    case 'reviewed':
      return 'yellow';
    case 'created':
    case 'dispatched':
      return 'gray';
    case 'correctionsRequested':
      return 'yellow';
    default:
      return 'gray';
  }
};

export const getScanStatusText = ({
  archivedAt,
  scanType,
  status,
}: {
  archivedAt?: Date;
  scanType?: ScanType;
  status?: ScanStatus | ScanLifecycleStatus;
}) =>
  archivedAt
    ? 'Archived ' + formatDate(archivedAt)
    : scanType === 'progress'
    ? 'approved'
    : status
    ? SCAN_STATUS_PRESENTATION_TEXT[status]
    : 'TBD';

export const ScanStatusPill = ({ status, color, small, tight = false, archivedAt, scanType, scan, statusOnly = false }: {
  status?: ScanStatus | ScanLifecycleStatus;
  color?: StatusColor;
  tight?: boolean;
  small?: boolean;
  archivedAt?: Date;
  scanType?: ScanType;
  statusOnly?: boolean;
  scan?: ApiScan;
}) => {
  if (scan) {
    status = scan.scanLifecycleStatus;
    scanType = scan.scanType;
  }
  color = color ?? getScanStatusPillColor(status, scanType);

  const statusText = getScanStatusText({ archivedAt, scanType, status });
  const statusTypeText = scanType ? SCAN_TYPE_PRESENTATION_TEXT[scanType] : undefined;
  return <StatusPill statusTypeText={statusOnly ? undefined : statusTypeText} statusText={statusText} color={color} small={small} tight={tight} />;
};
